module.exports = __webpack_public_path__ + "img/astronaut-helmet.c8df5448.svg";